module.exports = __webpack_public_path__ + "img/404bg.e0d1d201.jpg";